export default date => {
  // 当前学年
  date = date || new Date()
  let year = date.getFullYear()
  let month = date.getMonth()
  let day = date.getDate()
  return (month < 7 || month < 8 && day < 10) ? (year - 1 + '~' + year) : (year + '~' + (year + 1))
}



// WEBPACK FOOTER //
// ./src/utils/term.js